import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import {
  ActivatedRoute,
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})

export class LandingComponent implements OnInit {

  public userRoles: Array<any> = new Array<any>();
  public loading: boolean;

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private route: ActivatedRoute) {
    this.loading = false;
  }

  ngOnInit() {
    this.globalService.setTitle('Asterisk');
    this.initializeLandingPage();
    if (this.globalService.showTeamLogos) {
      this.globalService.toolName = "Team Asterisk";
      this.globalService.headerLogo = "./assets/images/asterisk-header-new.png";
    } else {
      this.globalService.toolName = undefined;
      this.globalService.headerLogo = undefined;
    }

  }

  private async initializeLandingPage() {
    this.userRoles = this.globalService.user.roles.filter(role => role.type === 'landing');
    this.loading = false;
  }

  selectTool(route: any) {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });

    this.router.navigate([`..${route}`], { relativeTo: this.route });
  }

  ngOnDestroy() {
  }
}
